import { useFeatures } from '@udemy/react-experimentation-provider';
export const quickViewBoxFeatures = ['cart_loginsignup_redirect_to_checkout', 'desktop_post_add_to_cart_behavior', 'personal_plan_course_enrollment', 'fbt_force_go_to_cart'];
const personalPlanExplicitEnroll = feature => !!(feature !== null && feature !== void 0 && feature.configuration.enablePersonalPlanEnrollments);
export const useQuickViewBoxFeatures = () => {
  /**
   * @remarks Conditions for popover opening/delay and rendering wishlist are totally different. Even if we open a
   * popover, we may/may not render wishlist wrt conditions based on course/user/product data.
   *
   * So I'm just separating those into different functions.
   */
  const {
    featureVariantAssignments: features,
    isLoading
  } = useFeatures(quickViewBoxFeatures);
  const personalPlanExplicitEnrollFeature = features.get('personal_plan_course_enrollment');
  return {
    isLoading,
    personalPlanExplicitEnrollFeature: personalPlanExplicitEnroll(personalPlanExplicitEnrollFeature)
  };
};
//# sourceMappingURL=experimentation-helpers.js.map